import { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';

// Service status from status.2way.app (Better Stack), read through the backend
// (GET /system-status, cached there). One fetch for the whole app: the dashboard card and the
// app-wide bar share it. Refreshed every 5 minutes and when the tab comes back into focus.
// Shape: {available, state, updatedAt, pageUrl, components, incidents, maintenance}.
export const STATUS_PAGE_URL = 'https://status.2way.app';
export const ANNOUNCE_DAYS = 7;
const REFRESH_MS = 5 * 60 * 1000;
const MIN_GAP_MS = 30 * 1000;

let current = null;
let loadedAt = 0;
let inFlight = null;
const listeners = new Set();

const load = (force = false) => {
    if (inFlight || (!force && Date.now() - loadedAt < MIN_GAP_MS)) return inFlight;
    inFlight = axios.get(`${process.env.REACT_APP_API_URL}/system-status`)
        .then(({data}) => (data && data.available ? data : null))
        .catch(() => null)
        .then(value => {
            current = value;
            loadedAt = Date.now();
            inFlight = null;
            listeners.forEach(listener => listener(value));
        });
    return inFlight;
};

let timer = null;
const onFocus = () => load();

export const useSystemStatus = () => {
    const [status, setStatus] = useState(current);
    useEffect(() => {
        listeners.add(setStatus);
        if (listeners.size === 1) {
            timer = setInterval(() => load(true), REFRESH_MS);
            window.addEventListener('focus', onFocus);
        }
        load();
        return () => {
            listeners.delete(setStatus);
            if (!listeners.size) {
                clearInterval(timer);
                window.removeEventListener('focus', onFocus);
            }
        };
    }, []);
    return status;
};

// What is worth telling the user now: open incidents, maintenance in progress, and maintenance
// starting within ANNOUNCE_DAYS.
export const statusEvents = (status, now = moment()) => {
    if (!status) return {incidents: [], ongoing: [], planned: []};
    const maintenance = status.maintenance || [];
    return {
        incidents: status.incidents || [],
        ongoing: maintenance.filter(item => moment(item.startsAt).isSameOrBefore(now) && (!item.endsAt || moment(item.endsAt).isAfter(now))),
        planned: maintenance.filter(item => moment(item.startsAt).isAfter(now) && moment(item.startsAt).diff(now, 'days', true) <= ANNOUNCE_DAYS)
    };
};

export const maintenanceWindow = item => {
    const start = moment(item.startsAt);
    if (!item.endsAt) return start.format('ddd D MMM, HH:mm');
    const end = moment(item.endsAt);
    return `${start.format('ddd D MMM, HH:mm')}–${end.format(start.isSame(end, 'day') ? 'HH:mm' : 'ddd D MMM, HH:mm')}`;
};
